module.exports = __webpack_public_path__ + "img/chess_chesswhite1.32e11fa3.png";